import type { CompanyDetailsProps } from "@site-types/components/companyDetails"
import Sudoku from "../Sudoku"
import CompanyDetailsTable from "./CompanyDetailsTable"
import CompanyStory from "./CompanyStory"
import CompanyTimeline from "./CompanyTimeline"
export function CompanyDetails({ data }: CompanyDetailsProps) {
  return (
    <div className="relative">
      <CompanyStory />
      <CompanyTimeline historyItems={data.companyHistory} />
      <CompanyDetailsTable />
      <Sudoku />
    </div>
  )
}

export default CompanyDetails
